import _extends from '@babel/runtime/helpers/extends';
import { px2rem } from '../utils/helpers/style.js';

var textAreaAttributesWeb = {
  padding: {
    top: px2rem(28),
    right: px2rem(14),
    bottom: px2rem(14),
    left: px2rem(14)
  },
  fontSize: px2rem(18),
  label: {
    padding: {
      top: px2rem(14),
      right: 0,
      bottom: 0,
      left: px2rem(14)
    },
    fontSize: px2rem(18)
  }
};
var textAreaThemeWeb = _extends({}, textAreaAttributesWeb, {
  variants: {
    condensed: {
      fontSize: px2rem(16),
      label: {
        fontSize: px2rem(16)
      }
    }
  }
});

export { textAreaThemeWeb };
